import { Navigate, useLocation } from "react-router-dom";

const exactRedirects: Record<string, string> = {
  "/about-us": "/about",
  "/about-us/": "/about",
  "/selling-your-home": "/sell",
  "/selling-your-home/": "/sell",
  "/your-homes-value": "/propertyvaluation",
  "/your-homes-value/": "/propertyvaluation",
  "/address-search": "/search",
  "/address-search/": "/search",
  "/listing-id-search": "/search",
  "/listing-id-search/": "/search",
  "/mls-mobile-app": "/search",
  "/mls-mobile-app/": "/search",
  "/buyer-client-service": "/buy",
  "/buyer-client-service/": "/buy",
  "/the-decision-to-buy": "/buy",
  "/the-decision-to-buy/": "/buy",
  "/offer-closing-resources": "/buy",
  "/offer-closing-resources/": "/buy",
  "/alternative-financing": "/buy",
  "/alternative-financing/": "/buy",
  "/cost-comparisons": "/buy",
  "/cost-comparisons/": "/buy",
  "/your-real-estate-firm": "/about",
  "/your-real-estate-firm/": "/about",
  "/southern-utah-links": "/communities",
  "/southern-utah-links/": "/communities",
  "/southern-utah-lodging": "/communities",
  "/southern-utah-lodging/": "/communities",
  "/female-viagra-sale": "/",
  "/female-viagra-sale/": "/",
  "/home-inspection": "/home-inspection-guide",
  "/home-inspection/": "/home-inspection-guide",
  "/the-mortgage-process": "/mortgage-process",
  "/the-mortgage-process/": "/mortgage-process",
  "/negotiating-tips": "/negotiating-tips",
  "/negotiating-tips/": "/negotiating-tips",
  "/the-art-of-negotiating": "/negotiating-tips",
  "/the-art-of-negotiating/": "/negotiating-tips",
  // Redirect old SEO city URLs to new /communities/[slug] system
  "/st-george-real-estate": "/communities/st-george-utah",
  "/st-george-real-estate/": "/communities/st-george-utah",
  "/washington-ut-real-estate": "/communities/washington-utah",
  "/washington-ut-real-estate/": "/communities/washington-utah",
  "/ivins-real-estate": "/communities/ivins-utah",
  "/ivins-real-estate/": "/communities/ivins-utah",
  "/santa-clara-real-estate": "/communities/santa-clara-utah",
  "/santa-clara-real-estate/": "/communities/santa-clara-utah",
  "/hurricane-real-estate": "/communities/hurricane-utah",
  "/hurricane-real-estate/": "/communities/hurricane-utah",
};

const prefixRedirects: [string, string][] = [
  ["/idx/community/hurricane-valley", "/hurricane-homes"],
  ["/idx/", "/search"],
  ["/idx", "/search"],
  ["/find-a-neighborhood", "/communities"],
  ["/buy-or-sell-first", "/buy"],
];

function resolveRedirect(pathname: string): string | null {
  const lower = pathname.toLowerCase();

  // Legacy long-form market report URLs → new short slug (preserve month-year)
  const legacyMarketPrefix = "/market-reports/washington-county-ut-market-report-";
  if (lower.startsWith(legacyMarketPrefix)) {
    return "/market-reports/" + lower.slice(legacyMarketPrefix.length).replace(/\/$/, "");
  }

  // Handle /*/feed/ → redirect to parent path
  if (lower.endsWith("/feed/") || lower.endsWith("/feed")) {
    const parent = lower.replace(/\/feed\/?$/, "");
    if (parent && parent !== "/") {
      // Recurse to see if parent itself needs redirecting
      return resolveRedirect(parent) || parent;
    }
    return "/";
  }

  // Exact match
  if (exactRedirects[lower]) {
    return exactRedirects[lower];
  }

  // Prefix match (order matters - more specific first)
  for (const [prefix, target] of prefixRedirects) {
    if (lower.startsWith(prefix)) {
      return target;
    }
  }

  return null;
}

const LegacyRedirect = () => {
  const location = useLocation();
  const target = resolveRedirect(location.pathname);

  if (target) {
    return <Navigate to={target} replace />;
  }

  return null;
};

export { resolveRedirect };
export default LegacyRedirect;
